"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHttpServiceInstance = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class HttpService {
  constructor(props) {
    var _this = this;
    this.axiosInstance = void 0;
    this.requestQueue = [];
    this.isProcessing = false;
    this.setup = _ref => {
      let {
        api,
        tenant
      } = _ref;
      const {
        baseURL
      } = api;
      this.axiosInstance = _axios.default.create({
        baseURL,
        headers: {
          'X-Tenant': tenant.toLowerCase(),
          'vf-project': 'guidedSelling'
        }
      });
    };
    this.formatRequestLog = request => {
      const requestLog = {};
      requestLog.method = request.method.toUpperCase();
      requestLog.host = request.baseURL;
      requestLog.path = request.url;
      requestLog.headers = request.headers;
      if (request.data) {
        requestLog.body = request.data;
      }
      return requestLog;
    };
    this.formatResponseLog = response => {
      const responseLog = {};
      responseLog.headers = response.headers;
      responseLog.status = response.status;
      if (response) {
        responseLog.body = response.data;
      }
      return responseLog;
    };
    this.processQueue = async () => {
      if (this.isProcessing || this.requestQueue.length === 0) return;
      this.isProcessing = true;
      const {
        method,
        url,
        params,
        resolve,
        reject
      } = this.requestQueue.shift();
      try {
        const result = await this.httpRequest(method, url, params);
        resolve(result);
      } catch (error) {
        reject(error);
      } finally {
        this.isProcessing = false;
        this.processQueue();
      }
    };
    this.addToQueue = (method, url, params) => {
      return new Promise((resolve, reject) => {
        this.requestQueue.push({
          method,
          url,
          params,
          resolve,
          reject
        });
        this.processQueue();
      });
    };
    this.httpRequest = async function (method, url) {
      let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const requestObj = {
        method,
        url
      };
      if (params.data) {
        requestObj.data = params.data;
      }
      let rawResponse;
      const requestStart = Date.now();
      try {
        rawResponse = await _this.axiosInstance.request(requestObj);
        return rawResponse.data;
      } catch (e) {
        rawResponse = e.response;
        console.info(e);
        throw e;
      } finally {
        var _rawResponse;
        const requestEnd = Date.now();
        console.info([`${requestEnd - requestStart}ms`, _this.axiosInstance.getUri(requestObj), _this.formatRequestLog((_rawResponse = rawResponse) === null || _rawResponse === void 0 ? void 0 : _rawResponse.config), _this.formatResponseLog(rawResponse)]);
      }
    };
    this.get = async url => {
      return this.addToQueue('get', url);
    };
    this.post = async (url, data) => {
      return this.addToQueue('post', url, {
        data
      });
    };
    this.patch = async (url, data) => {
      return this.addToQueue('patch', url, {
        data
      });
    };
    if (HttpService.instance) {
      return HttpService.instance;
    }
    this.setup(props);
    HttpService.instance = this;
  }
  static getInstance(props) {
    if (!HttpService.instance) {
      HttpService.instance = new HttpService(props);
    }
    return HttpService.instance;
  }
}
HttpService.instance = null;
const getHttpServiceInstance = props => HttpService.getInstance(props);
exports.getHttpServiceInstance = getHttpServiceInstance;